import { render, staticRenderFns } from "./TokensCollection.vue?vue&type=template&id=abd5dac0&"
import script from "./TokensCollection.vue?vue&type=script&lang=js&"
export * from "./TokensCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports